import { useMemo } from 'react';
import { ExperienceResource, ExperienceResourceArray } from '../../../../Types';

export function useExperienceMap(
  experiencesArray: ExperienceResourceArray,
): Record<number, ExperienceResource> {
  return useMemo(() => {
    return experiencesArray.reduce(
      (acc, resource) => {
        acc[resource.payload.id] = resource;
        return acc;
      },
      {} as Record<number, ExperienceResource>,
    );
  }, [experiencesArray]);
}
